/**
 * Ícones disponíveis para o componente de erro.
 */
export enum ErrorIcons {
  UPDATE = 'update',
  CAMERA = 'camera',
}
